//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { createNamespacedHelpers } from 'vuex'
import { CatChoosePeople } from 'counselor-mobile-ui'

const { mapGetters } = createNamespacedHelpers('choosePeople')

export default {
  components: { CatChoosePeople },

  computed: {
    ...mapGetters([
      'dataList',
      'historyApiMethod',
      'searchApiMethod',
      'addHistoryApiMethod',
      'searchParams',
      'historyParams',
      'setAddHistoryParams',
    ]),
  },

  mounted () {
    window.history.pushState(null, null, document.URL)
    window.addEventListener('popstate', this.addRouterChangeByTest, false)
  },

  methods: {
    getChooseDataFn (data) {
      this.$EventBus.$emit('get-choose-data', data)
    },

    addRouterChangeByTest () {
      if (this.$refs?.CatChoosePeople?.showSelected) {
        window.history.pushState(null, null, document.URL)
        this.$refs.CatChoosePeople.showSelected = false
      } else {
        this.$router.go(-1)

        // window.history.go(-1)
        window.removeEventListener('popstate', this.addRouterChangeByTest)
      }
    },
  },
}
